import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/web-frontend/web-frontend/layouts/default.vue").then(m => m.default || m))
}